/*eslint-disable no-unused-vars*/

import {createApp} from 'vue'
import Maska from 'maska'
import form from '@/store/form'
import './assets/js/css/ImportCss'
import {Fancybox} from '@fancyapps/ui'
import SwiperSlider from '@/assets/js/Swiper/Swiper'
import ButtonAll from '@/assets/js/Button/All/ButtonAll'
import ButtonGallery from '@/assets/js/Button/Gallery/ButtonGallery'
import Faq from '@/assets/js/Faq/Faq'
import HeaderFixed from '@/assets/js/Header/Fixed/HeaderFixed'
import HeaderMobile from '@/assets/js/Header/Mobile/HeaderMobile'
import MenuMobile from '@/assets/js/Menu/Mobile/MenuMobile'
import CompanyFaq from '@/assets/js/Company/Faq/CompanyFaq'
import AppFormPopup from '@/components/Form/AppFormPopup.vue'

// Подключаем глобально jQuery
const $ = window.$ = window.jQuery = require('jquery')

document.addEventListener('DOMContentLoaded', () => {
	Fancybox.bind('[data-fancybox]', {
		mainClass: 'fancybox--popup'
	})

	Fancybox.bind('[data-fancybox-form]', {
		mainClass: 'fancybox---form'
	})

	new SwiperSlider()
	new ButtonAll()
	new ButtonGallery()
	new Faq()
	new HeaderFixed()
	new HeaderMobile()
	new MenuMobile()
	new CompanyFaq()

	if (document.getElementById('block--form-popup') != null) {
		createApp({})
			.component('block-form-popup', AppFormPopup)
			.use(Maska)
			.use(form)
			.mount('#block--form-popup')
	}
})
